/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc) {
	'use strict';

	/**
	 * Add hash & querystring to link url
	 *
	 * @author Dimitri Sebeschuk
	 * @namespace Tc.Module
	 * @class LinkForwarder
	 * @extends Tc.Module
	 */
	Tc.Module.LinkForwarder = Tc.Module.extend({

		on: function (callback) {
			var mod = this;

			if (mod.$ctx.prop('tagName') === 'A') {
				mod.enhanceUrl(mod.$ctx);
			} else {
				mod.$ctx.find('a').each(function () {
					mod.enhanceUrl($(this));
				})
			}
			callback();
		},

		enhanceUrl: function (a) {
			var href = a ? a.attr('href') : '',
				url = href.split('?')[0],
				origSearch = a ? a.prop('search').substring(1) : '',
				origHash = a ? a.prop('hash') : '',
				query = window.location.search.length ? window.location.search : '';

			//add search
			query = query ? (origSearch ? query + '&' + origSearch : query) : (origSearch ? '?' + origSearch : '');
			//add hash
			query = query + (window.location.hash ? ( origHash ? window.location.hash + '&' + origHash : window.location.hash ) : ( origHash ? '#' + origHash : '' ));

			if (url && query) {
				a.attr('href', url + query);
			}
		}
	});

})(window.Tc.$, window.Tc);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.LinkForwarder.js
// module id = 331
// module chunks = 0